import { init, tanstackRouterBrowserTracingIntegration } from "@sentry/react";
import { sharedSentryConfig } from "@vyne-shared/utils/sentryConfig";
import configuration from "utils/config";
import type { paymentsUiRouter } from "components/Navigation/paymentsUiRouter";

/** Function to initialize Sentry integration. */
export function initSentry(router: typeof paymentsUiRouter) {
    const routingInstrumentation = tanstackRouterBrowserTracingIntegration(router);

    init({
        ...sharedSentryConfig(configuration, routingInstrumentation),
        dsn: "https://e20631a7241d4983951ad603a31dcd70@o119772.ingest.sentry.io/5995648",
    });
}
